// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'jquery'
import axios from 'axios'
import VueSwiper from 'vue-awesome-swiper'
import global from './api/global_variable'
import Video from 'video.js'

import Header from './components/header'
import Footer from './components/footer'
import Suspension from './components/suspension'
import echarts from 'echarts'
import 'swiper/css/swiper.css'
import '@/styles/public.css'
import 'video.js/dist/video-js.css'
import http from './request/http'
import Tips from './components/tips'
import VideoPlay from './components/videoPlay'
import open from './util/consulting';
axios.defaults.withCredentials = true

Vue.prototype.$http = http;
Vue.prototype.$video = Video
Vue.prototype.$echarts = echarts
Vue.prototype.$ajax = axios
Vue.prototype.$open = open;
Vue.use(VideoPlay)
Vue.use(Tips)
Vue.use(VueSwiper)
Vue.use(Header)
Vue.use(Footer)
Vue.use(Suspension)
Vue.config.productionTip = false
Vue.prototype.global = global


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  methods: {

  }
})



// WEBPACK FOOTER //
// ./src/main.js